<!--
 * @Description: 
 * @Author: jiawei
 * @Date: 2021-07-30 16:07:31
 * @LastEditTime: 2021-08-06 09:48:36
 * @LastEditors: jiawei
 * @Reference: 
-->
<template>
    <div>
    <Form ref="formItem" :model="formItem" :label-width="80" :rules="ruleValidate">
       <Row  style="margin-bottom: 10px;">
                <Col span="6">
                    <FormItem label="标题"  prop="title">
                        <Input v-model="formItem.title" placeholder="请输入标题"></Input>
                    </FormItem>
                </Col>
        </Row>
        <Row>
                <Col span="14">
                    <FormItem label="资讯简介" prop='infDescribe'>
                        <Input v-model="formItem.infDescribe" maxlength=100 type="textarea" :rows="4"  placeholder="请输入内容"></Input>
                    </FormItem>
                </Col>
        </Row>
        <Row>
                <Col span="14">
                    <FormItem label="资讯图片" prop='pic'>
                        <div class="demo-upload-list" v-for="item in uploadList">
                                <template>
                                    <img :src="'http://39.104.118.120:8099/app/updown/returnImageStream?a='+item.fileName + '&imgPath='+item.listImage">
                                    <div class="demo-upload-list-cover">
                                        <Icon type="ios-eye-outline" @click.native="handleView(item.fileName)"></Icon>
                                        <Icon type="ios-trash-outline" @click.native="handleRemove(item)"></Icon>
                                    </div>
                                </template>
                        </div>
                            <Upload
                                ref="upload"
                                :show-upload-list="false"
                                :default-file-list="defaultList"
                                :on-success="handleSuccess"
                                :format="['jpg','jpeg','png']"
                                :before-upload="handleBeforeUpload"
                                multiple
                                type="drag"
                                :action="uploadUrl"
                               
                                style="width:58px;">
                                <div v-if="successType" style="width: 58px;height:58px;line-height: 58px;"  >
                                    <Icon type="ios-camera" size="20"></Icon>
                                </div>
                            </Upload>
                            <Modal title="查看图片" v-model="visible" v-if="uploadList.length>0">
                                <img :src="'http://39.104.118.120:8099/app/updown/returnImageStream?a='+uploadList[0].fileName + '&imgPath='+uploadList[0].listImage">
                            </Modal>
                    </FormItem>
                </Col>
        </Row>
         <Row  style="margin-bottom: 10px;">
                <Col span="6">
                    <FormItem label="链接"  prop="url">
                        <Input v-model="formItem.url" placeholder="请输入链接"></Input>
                    </FormItem>
                </Col>
        </Row>
        
        
        <FormItem>
            <Button type="primary" @click="save('formItem')">提交</Button>
        </FormItem>
    </Form>
    </div>
</template>

<script>
export default {
    name: 'EbizUiAnnouncementmanagement',
    data() {
        return {
            formItem: {
                listImage:'',
                // fileName:'',
                title: '',
                infDescribe: '',
                url:''
            },
            defaultList: [],
            successType:true,
            imgName: '',
            visible: false,
            uploadList: [],
            uploadUrl:'',
            headers: { sid: window.sessionStorage.getItem("sid") },
            ruleValidate: {
                 title: [
                        { required: true, message: '请输入标题', trigger: 'blur' }
                    ],
                 infDescribe: [
                        { required: true, message: '内容不能为空', trigger: 'blur' }
                    ],
                 url: [
                        { required: true, message: '链接不能为空', trigger: 'blur' }
                    ],
             }
        };
    },

    mounted() {
          this.uploadUrl = this.$api.saveuploadImage;
        //   console.log(this.$api.saveuploadImage);
    },

    methods: {
        save(name) {
            this.$refs[name].validate((valid) => {
                    if (valid) {
                        this.$Modal.confirm({
                            title: '提交',
                            content: '<p>是否提交</p>',
                            onOk: () => {
                                this.$api.savePublicAdd(this.formItem).then(res=>{
                                    if (res.result== 0) {
                                        this.$Message.success('提交成功');
                                        this.formItem ={}
                                        this.uploadList = []
                                        this.successType =true
                                    } else {
                                          this.$Message.error(res.resultMessage);
                                    }
                                })
                            },
                            onCancel: () => {
                            }
                        });
                    } 
                })
        },
         handleView () {
                this.imgName = '查看图片';
                this.visible = true;
            },
            handleRemove (file) {
                 this.successType =true
                 this.formItem.listImage = ''
                 this.uploadList = []
            },
            handleSuccess (res, file) {
                if (res.content.result==0) {
                    this.successType =false
                    this.formItem.fileName = file.name
                    this.formItem.listImage =res.content.path
                    // console.log( res.content.path.replace(/\+/g, '%2B'),'44444444444444444444444444444');
                    this.uploadList = [{filePath:res.content.path,listImage:res.content.path.replace(/\+/g, '%2B')}]
                }
            },
            handleFormatError (file) {
                console.log(file);
            },
            handleBeforeUpload () {
                const check = this.uploadList.length < 1;
                if (!check) {
                    this.$Notice.warning({
                        title: '只能上传一张图片'
                    });
                }
                return check;
            }
    },
};
</script>

<style lang="less" scoped>
    /deep/.demo-upload-list {
    width: 100px;
    height: 100px;
    text-align: center;
    line-height: 60px;
    border: 1px solid transparent;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    position: relative;
    -webkit-box-shadow: 0 1px 1px rgb(0 0 0 / 20%);
    box-shadow: 0 1px 1px rgb(0 0 0 / 20%);
    margin-right: 4px;
}
</style>